var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.searching)?_c('div',{staticClass:"c-search"},[_c('p',{staticClass:"c-search__caption"},[_vm._v(" "+_vm._s(_vm.$t('search.results'))+" \""+_vm._s(_vm.keyword)+"\" ")]),_c('ui-results',{attrs:{"products":_vm.products,"recommends":_vm.recommends}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }